module.exports = __webpack_public_path__ + "img/demo-slick.7588e100.jpg";